export default __webpack_public_path__ + "static/media/1.39bbe02f.png";